export default __webpack_public_path__ + "static/media/the-fa-slavery-human-trafficking-statement-2020.c59a53cd.pdf";